export function anchors() {
    const body = $("body");
    const $menu = $(".header")

    body.on('click', ".has-anchor", function (e) {
        e.preventDefault();

        const target = $(this).attr("href").slice(1);

        if (target) {
            const anchoredBlock = $(`[id=${target}]`);
            const anchoredBlockTop = $(`[id=${target}]`).offset().top;
            const winTop = $(window).scrollTop();
            let headerHeight;
            if (anchoredBlockTop > winTop) {
                headerHeight = 0;
            } else {
                headerHeight = $menu.innerHeight() + 30;
            }
            if (anchoredBlock.length) {
                $("html, body").animate({scrollTop: anchoredBlockTop - headerHeight}, 500);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchors.js